import ar from "./ar";
import en from "./en";
import tr from "./tr";

const LOCALES = { ar, en, tr };
export default LOCALES;
